//- Handle cookies for VSL Play button
if (!$.cookie('DRC-VSL-Recode')) {
  videojs('GundryMDVSL').ready(function () {
    this.on('timeupdate', function () {
      if (this.currentTime() >= (60 * timePlaying) || this.currentTime() == this.duration()) {
        $("#videoCTAWrap").removeClass('hide');
      }
    })
  });

  $.cookie("DRC-VSL-Recode", 1, { expires: 7 });
}
else {
  $("#videoCTAWrap").removeClass('hide');
}